import { useContext } from "react";

import { type SSOService } from "./SSOService";
import { SnapSSOAuthContext } from "./context";

export const useSnapSSOAuthService = (): SSOService => {
    const snapSSOAuthService = useContext(SnapSSOAuthContext);

    if (!snapSSOAuthService) {
        throw new Error("useSnapSSOAuthService() must be used within a <SnapSSOAuthProvider />");
    }

    return snapSSOAuthService;
};
